module.exports = __webpack_public_path__ + "img/c3.f8663185.jpg";